import { createSlice } from "@reduxjs/toolkit";
import { auth } from "../../firebase.config";
import { loadPassportFromStorage, savePassportToStorage } from "../../constans/functions/storage";
import { loadPassportFromFirestore, savePassportToFirestore } from "../../constans/functions/passportServices";



export const passportSlice = createSlice({
    name: 'passport',
    initialState: {
        passport: null,
        isLoading: false,
        isLoadedFromCache: false
    },

    reducers: {
        setPassport: (state, { payload }) => {
            state.passport = payload;
            savePassportToStorage(payload);
        },

        setPassportFromCache: (state, { payload }) => {
            state.passport = payload;
            state.isLoadedFromCache = true;
            state.isLoading = false;
        },

        setLoading: (state, { payload }) => {
            state.isLoading = payload;
        },

        setLoadedFromCache: (state, { payload }) => {
            state.isLoadedFromCache = payload;
        },

        clearPassport: (state) => {
            state.passport = null;
            savePassportToStorage(null);
        }
    }
});


export const {
    setPassport,
    setPassportFromCache,
    setLoading,
    setLoadedFromCache,
    clearPassport
} = passportSlice.actions;


// Thunks
export const setPassportWithSync = (passport) => async (dispatch) => {
    try {
        dispatch(setPassport(passport));
        if (auth.currentUser) {
            await savePassportToFirestore(
                auth.currentUser.uid,
                passport
            );
        }

    } catch (err) {
        console.error('Error saving passport:', err);
    }
};

export const loadUserPassport = () => async (dispatch) => {
    if (!auth.currentUser) return;
    const cachedPassport = loadPassportFromStorage();
    if (cachedPassport) {
        dispatch(setPassportFromCache(cachedPassport));
    }
    try {
        dispatch(setLoading(true));
        const passport = await loadPassportFromFirestore(
            auth.currentUser.uid
        );
        dispatch(setPassport(passport));
        dispatch(setLoading(false));

    } catch (err) {
        console.error('Error loading passport:', err);
        dispatch(setLoading(false));
    }
};


export const clearPassportWithSync = () => async (dispatch) => {
    try {
        dispatch(clearPassport());
        if (auth.currentUser) {
            await savePassportToFirestore(
                auth.currentUser.uid,
                null
            );
        }
    } catch (err) {
        console.error('Error clearing passport:', err);
    }
};